import { useRef } from 'react';

import { useRuntime } from '@xing-com/crate-xinglet/internal';
import { extractExperiments, registerExperiment } from '@xing-com/splitkit';

export const useRegisterExperiments = (): void => {
  const runtime = useRuntime();
  const registered = useRef(false);

  if (registered.current) return;

  const { globalRegisteredExperiments } = extractExperiments(
    runtime.metadataMap,
    runtime.config.viewerCountry
  );

  for (const {
    name,
    supportedVariants,
    experimentType,
  } of globalRegisteredExperiments) {
    registerExperiment(name, supportedVariants, experimentType);
  }

  registered.current = true;
};
